import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M14 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}]]

/**
 * IconBrandFlickr
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtZmxpY2tyIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDEyYTMgMyAwIDEgMCA2IDBhMyAzIDAgMSAwIC02IDAiIC8+CiAgPHBhdGggZD0iTTE0IDEyYTMgMyAwIDEgMCA2IDBhMyAzIDAgMSAwIC02IDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/brand-flickr
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandFlickr = createReactComponent('outline', 'brand-flickr', 'BrandFlickr', __iconNode);

export default IconBrandFlickr;